import { render } from "./PersistentScrollbar.vue?vue&type=template&id=4096bb4f&ts=true"
import script from "./PersistentScrollbar.vue?vue&type=script&lang=ts"
export * from "./PersistentScrollbar.vue?vue&type=script&lang=ts"

import "./PersistentScrollbar.vue?vue&type=style&index=0&id=4096bb4f&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__